module.exports = __webpack_public_path__ + "img/chanceofflurries.50c3370b.png";